import styled from 'styled-components'
import { fadeIn } from 'common'

export const BottomSheetTextSectionContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const BottomSheetContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: center;
  align-items: center;
  animation: ${fadeIn} 0.3s linear;

  .success-error-title {
    text-align: center;
    margin-bottom: 0.5rem;
  }

  section h3 {
    margin-bottom: 4px;
  }

  .nohover:not(.fix-hover):hover {
    background-color: var(--button-background-color);
  }

  button::after {
    z-index: 0;
  }
`

export const PendingSvgWrapper = styled.div`
  display: flex;
  background-color: #ffc700;
  border-radius: 50%;
  height: 64px;
  width: 64px;
  justify-content: center;
  align-items: center;
  margin: 24px 0;
`

export const ReportCardContainerBulletPoints = styled.section`
  display: flex;
  flex-direction: column;
  gap: 8px;
`
